module.exports = __webpack_public_path__ + "static/media/dealiem_favicon.031c3d4a.ico";